import HeaderPortal from "components/portal/header-portal";
import { Button } from "ui/components/button";
import CreateItemButton from "components/buttons/create";
import EmployeeInput from "components/employee/input";
import { PermissionGate } from "permissions/components/gate";
import React from "react";
import { useState } from "react";
import { invalidateAllQueries } from "utils/utils";
import { toast } from "sonner";
import { addFolderAccess } from "./api";
import { eventBus } from "utils/eventBus";

const FolderEmplopyeesInputSheet = ({ employees, drive_id, folder_id }) => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const handleConfirm = async () => {
    if (selectedEmployees.length > 0 && folder_id) {
      try {
        const response = await addFolderAccess({
          folder_id: folder_id,
          employees: selectedEmployees.map((emp) => emp.id),
        });
        toast.success(response?.message || "Employees successfully added to Google Drive folder!");
        invalidateAllQueries();
        eventBus.emit("refresh:list", `drive/folder/list_access${drive_id}`);
      } catch (error) {
        const errorMessage = error?.response?.errors?.[0]?.message || error?.message || "Failed to add employees to Google Drive folder";
        toast.error(errorMessage);
        console.error(error);
      }
    }
  };

  function renderFooter({ setOpen, setSelectedEmployees }) {
    return (
      <Button
        onClick={() => {
          handleConfirm();
          setSelectedEmployees([]);
          setOpen(false);
        }}
      >
        Select
      </Button>
    );
  }

  return (
    <>
      <EmployeeInput
        multiselect={true}
        value={selectedEmployees}
        onChange={setSelectedEmployees}
        allowRemoval={true}
        footer={renderFooter}
        excludedEmployeeIds={[
          ...((employees?.items || employees) || []).map((item) => item.employee.id),
          ...selectedEmployees.map((emp) => emp.id),
        ]}
      >
        <HeaderPortal>
          <PermissionGate
            rule="update:PC,JC"
            collection="jobs"
            showWhenDisabled={false}
          >
            <CreateItemButton>Employees</CreateItemButton>
          </PermissionGate>
        </HeaderPortal>
      </EmployeeInput>
    </>
  );
};

export default FolderEmplopyeesInputSheet;
